import React from 'react';
import * as AntIcons from '@ant-design/icons';
import './IconWithBorders.css';
import PropTypes from 'prop-types';

const IconWithBorders = ({ icon, fontSize = '28' }) => {
  const formattedIconName = icon
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('');

  const iconVariants = [
    `${formattedIconName}Outlined`,
    `${formattedIconName}Filled`,
    `${formattedIconName}TwoTone`,
    formattedIconName,
  ];

  let IconComponent = null;
  for (const variant of iconVariants) {
    if (AntIcons[variant]) {
      IconComponent = AntIcons[variant];
      break;
    }
  }

  if (!IconComponent) {
    return null;
  }

  return (
    <div className="icon-container">
      <IconComponent style={{ fontSize: `${fontSize}px` }} />
    </div>
  );
};

IconWithBorders.propTypes = {
  icon: PropTypes.string.isRequired,
  fontSize: PropTypes.string,
};

export default IconWithBorders;
